export const images = {
    widgetcart: require('./widget-cart.svg').default as string,
    widgetrevenue: require('./widget-revenue.svg').default as string,
    widgettraded: require('./widget-traded.svg').default as string,
    alert: require('./alert.svg').default as string,
    assettracking: require('./asset-tracking.svg').default as string,
    hero_bg: require('./hero_bg_mobile.jpg'),
    cybersecurity: require('./cybersecurity.svg').default as string,
    coins: require('./coins.svg').default as string,
    banknotes: require('./banknote.svg').default as string,
    credit_card: require('./credit_card.svg').default as string,
    mobile: require('./mobile.svg').default as string,
    close_icon: require('./close_icon.svg').default as string,
    menu_icon: require('./menu_icon.svg').default as string,
    payment: require('./payment.svg').default as string,
    telemetria: require('./telemetria.svg').default as string,
    gestioneaccessi: require('./gestione-accessi.svg').default as string,
    side: require('./side.svg').default as string,
    cashback: require('./cashback.png'),
    deviceoverview: require('./device-overview.png'),
    cashstatus: require('./cash-status.png'),
    app_hand_token: require('./app_hand_token.png'),
    ATM: require('./retailATM-2.png'),
    case: require('./case.png'),
    board: require('./board.png'),
    case_isolated: require('./case.png'),
    industria40: require('./industria40.jpg'),
    industria40_2: require('./industria-40-credito-imposta.jpg'),
}